function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var V1_URL = 'https://app.parallelmarkets.com/sdk/v1/parallel.js';
var findScript = function findScript() {
  var _;
  return (_ = _toConsumableArray(document.querySelectorAll("script[src^=\"".concat(V1_URL, "\"]")))[0]) !== null && _ !== void 0 ? _ : null;
};
var addScript = function addScript() {
  var script = document.createElement('script');
  script.src = V1_URL;
  var headOrBody = document.head || document.body;
  if (!headOrBody) throw new Error('Parallel JS cannot be added to page with no <head/> or <body/> element');
  headOrBody.appendChild(script);
  return script;
};
var parallelPromise = null;
var loadScript = function loadScript() {
  // Load parallel script at most once
  if (parallelPromise !== null) return parallelPromise;
  parallelPromise = new Promise(function (resolve, reject) {
    // if we were imported on a server immediately return
    if (typeof window === 'undefined') {
      resolve(null);
      return;
    }
    if (window.Parallel) {
      resolve(window.Parallel);
      return;
    }
    try {
      var script = findScript();
      if (!script) script = addScript();
      script.addEventListener('load', function () {
        if (window.Parallel) {
          resolve(window.Parallel);
        } else {
          reject(new Error('Parallel JS SDK is not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Parallel JS SDK'));
      });
    } catch (error) {
      reject(error);
    }
  });
  return parallelPromise;
};

// Wait a tick and then try to load the script.  This is done
// to load the SDK upon library import.
Promise.resolve().then(function () {
  return loadScript();
})["catch"](console.warn);
var loadCalled = false;
var loadParallel = function loadParallel(config) {
  if (loadCalled) {
    var error = new Error('You cannot call loadParallel more than once');
    return Promise.reject(error);
  }
  loadCalled = true;
  return loadScript().then(function (Parallel) {
    if (!Parallel) return Promise.resolve(null);
    return new Promise(function (resolve, reject) {
      var onInit = function onInit() {
        return resolve(Parallel);
      };
      Parallel.init(_objectSpread(_objectSpread({}, config), {}, {
        on_init: onInit
      }));
    });
  });
};

export { loadParallel };
